module.exports = __webpack_public_path__ + "media/images/payment_cards/credit_cards/amex-44f5cd5c99417474c2a8ba5aaa720b57.png";